<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
         <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-separator-1">
              <li class="breadcrumb-item"><router-link to="/user"><a href="#">Users</a></router-link></li>
              <li class="breadcrumb-item active" aria-current="page">User Name</li>
            </ol>
          </nav>
          <div class="page-title">
            <h3>User Name</h3>
            <div id="backbtn" class="search-create" v-if="currentPage === 'dashboard'">
              <router-link to="/admindashboard" class="btn btn-primary">
                <i class="material-icons">arrow_back</i>
                Back to Dashboard
              </router-link>
            </div>
            <div class="search-create" v-if="currentPage === 'userlistpage'">
              <router-link to="/user" class="btn btn-primary">
                <i class="material-icons">arrow_back</i>
                Back to User List
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-md-12">
          <div class="card">
          <!--<div class="card-body brand-detail">-->
            <div class="card-body">
              <div class="row mb-50">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">User ID :</label>
                    <span class="value"> {{ userDetails.user.uid }}</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Email :</label>
                    <span class="value">{{ userDetails.user.email }}</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Status :</label>
                    <span class="value">{{ userDetails.user.status }}</span> 
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">Name :</label>
                    <span class="value">{{ userDetails.user.firstname }} {{ userDetails.user.lastname }}</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label">User Type :</label>
                    <!--<span class="value">{{ userDetails.user.role }}</span> --> 
                    <span class="value">{{ userDetails.user.user_type }}</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label"></label>
                    <span class="value"></span> 
                  </div>
                </div>
              </div>
              <div class="page-title">
                <h5>Assigned invoice</h5>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Invoice ID</th>
                    <th scope="col">Payment</th>
                    <th scope="col">Brand</th>
                    <th scope="col">Ghost</th>
                    <th scope="col">User A</th>
                    <th scope="col">User B</th>
                    <th scope="col">User C</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(invoiceDetail, index, key) in invoiceDetails">
                     <td v-if="invoiceDetail.stripe_invoice_id === ''" >#TEMP000{{ index }}</td>
                     <td v-if="invoiceDetail.stripe_invoice_id !== ''" >{{invoiceDetail.invoice_number }}</td>
                     <td>${{invoiceDetail.amount}}</td> 
                     <td>{{invoiceDetail.brand_name}}</td>
                     <td >{{invoiceDetail.admin_percentage}}%</td>
                     <td >{{invoiceDetail.userA_percentage}}%</td>
                     <td >{{invoiceDetail.userB_percentage}}%</td>
                     <td >{{invoiceDetail.userC_percentage}}%</td>
                     <td>{{invoiceDetail.status}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'userDetail',
    components: {
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        userDetails: {
          user: {
            uid: '',
            email: '',
            status: '',
            name: '',
            role: ''
          }
        },
        invoiceDetails: [],
        BrandDatas: [],
        invoicePartyDatas: [],
        currentPage: ''
      }
    },
    methods: {
    },
    mounted () {
      var jwttoken = localStorage.getItem('jwt')
      var currentUrl = window.location.href
      var splitUrl = currentUrl.split('/')
      var uId = splitUrl[4]
      var page = splitUrl[5]
      this.currentPage = page
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserDetail' + '?' + 'uid' + '=' + uId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.userDetails = response.data.results
          this.invoiceDetails = response.data.results.invoiceList
          this.BrandDatas = response.data.results.invoiceBrandData
          this.invoicePartyDatas = response.data.results.invoicePartyData
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/userDetail.vue